import { Flex, Button, Spacer, Center, Image, Text, Divider, Box, Link } from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

// Componentes
import FormularioDown from '../Formulario/FormularioDown';
import enviroments from '../../Services/enviroments';
import SlideModal from '../Slide/SlideModal';
import Footer from '../Footer/Footer';

// Images
import Logo from '../../Assets/Logos/logoL.webp';
import Whatsapp from '../../Assets/GENERALES/whatsapp.webp';

const Navbar = ({ children }) => {
    const [openSlideModal, setOpenSlideModal] = useState(false);
    const [viewButtonWp, setViewButtonWp] = useState(false);
    const [urlWp, setUrlWp] = useState('');
    const [idWp, setIdWp] = useState('');
    const [id, setId] = useState('');

    const queryString = window.location.search;
    let urlParams = new URLSearchParams(queryString);

    const location = useLocation();
    const navigate = useNavigate();

    let campaignid = urlParams.get('campaignid');
    let adgroupid = urlParams.get('adgroupid');
    let anuncioGroup = urlParams.get('group');
    let keyword = urlParams.get('keyword');
    let origen = urlParams.get('origin');
    let gclid = urlParams.get('gclid');
    let adId = urlParams.get('adId');
    let type = urlParams.get('type');

    useEffect(() => {
        if (location.pathname === `${enviroments.urlBase}/`) { setIdWp('button_whatsapp_movil'); setId('Form_Header'); setUrlWp(''); };
    }, [location])

    const activeRoute = (routeName) => {
        return location.pathname === routeName ? "active" : "";
    };

    const openSlide = () => {
        setOpenSlideModal(!openSlideModal);
    };

    return (
        <>
            {/* Navbar */}
            <Flex
                px={{ base: 3, md: 10 }}
                py={2}
                w="100%"
                alignItems='center'
            >
                <Image 
                    src={Logo} 
                    onClick={() => navigate(`${enviroments.urlBase}${origen ? `?origin=${origen}` : ''}${gclid ? `?gclid=${gclid}` : ''}${type ? `&type=${type}`: ''}${campaignid ? `&campaignid=${campaignid}` : ''}${adgroupid ? `&adgroupid=${adgroupid}` : ''}${anuncioGroup ? `&group=${anuncioGroup}` : ''}${keyword ? `&keyword=${keyword}` : ''}${adId ? `&adId=${adId}` : ''}`)} 
                    cursor='pointer' 
                    width='12%'
                    h='100%'

                    alt="logo digicel" 
                />
                <Spacer />
                <Center>
                    <Button  borderRadius={'30px'} bg="#E4002B" onClick={() => openSlide()} size={{ base: 'sm', md: 'md' }} textDecoration='none !important' color="white" _hover={{ border: '1px solid #E4002B', color: '#E4002B', bg: 'white' }} className="Subtitle" id='Click-to-call-desktop'>
                        <Text letterSpacing={'1px'} px='5'>
                            Contact Us
                        </Text>
                    </Button>
                </Center>
            </Flex>

            {/* División */}
            <Divider h='2px' bg='gray.200' />
            
            <Box pos='relative'>
                {children}
                <FormularioDown />
            </Box>

            {
                openSlideModal &&
                <Box
                    position="fixed"
                    top="0"
                    left="0"
                    width="100%"
                    height="100%"
                    backgroundColor="rgba(0, 0, 0, 0.5)"
                    zIndex="9"
                >
                    <SlideModal 
                        setOpenSlideModal={setOpenSlideModal} 
                        openSlideModal={openSlideModal} 
                        submitInitial={false} 
                        plan='Formulario general'
                        valuePhoneInitial={''}
                        id={id} 
                    />
                </Box>
            }

            <Footer />
        </>
    )
}

export default Navbar;